import * as fromRouter from "@ngrx/router-store";
import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from "@ngrx/store";
import { Constants } from "../interfaces/constants";

export interface State {
  version: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  router: fromRouter.RouterReducerState<any>;
}

export const initialState: State = {
  version: "1.0.0",
  router: null
};

// eslint-disable-next-line
export const selectRouter = createFeatureSelector<
  State,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fromRouter.RouterReducerState<any>
>("router");

const {
  selectQueryParam, // factory function to select a query param
  selectRouteParam // factory function to select a route param
} = fromRouter.getRouterSelectors(selectRouter);

export const selectCirculationId = selectRouteParam(
  Constants.routeParams.circId
);
export const selectStepId = selectRouteParam(Constants.routeParams.stepId);
export function selectMappedStepId<T>(map: {
  (id: string): T;
}): MemoizedSelector<State, T> {
  return createSelector(selectStepId, (stepId) => map(stepId));
}

export const selectTemplateId = selectRouteParam(
  Constants.routeParams.templateId
);
export const selectPrepareId = selectRouteParam(
  Constants.routeParams.prepareId
);
export const selectAction = selectQueryParam(Constants.queryParams.action);
export const selectHostUrl = selectQueryParam(Constants.queryParams.hostUrl);
